import React from 'react'
import { Spin } from 'antd'
import styled from 'styled-components'
import { Box } from 'widgets/Box'

const Wrapper = styled(Box)<{ background?: string; borderRadius?: string; width?: string }>`
  border: unset;
  cursor: pointer;
  background: ${({ background }) => background || 'linear-gradient(93.84deg, #006DFE 8.38%, #2AF6FF 114.84%)'};
  border-radius: ${({ borderRadius }) => borderRadius || '10px'};
  position: relative;
  font-size: 14px;
  ${({ width }) => {
    if (width) {
      return `
        padding: 10px 0px;
        width: ${width};
      `
    }
    return `
      padding: 10px 24px;
    `
  }}

  &:disabled {
    /* filter: grayscale(100%); */
    background-color: #262b34;
  }

  & > div {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 150%;
    color: #ffffff;
    display: flex;
    justify-content: center;

    @media (min-width: 991px) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  &[data-hover='true'],
  &[data-loading='true'] {
    cursor: default;
  }

  .ant-spin {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &[disabled],
  &[disabled='true'] {
    cursor: not-allowed;
  }
`

const BaseButton: React.FC<any> = ({
  loading = false,
  disabled = false,
  disableHover = false,
  background,
  borderRadius,
  width,
  onClick,
  children,
  ...props
}) => {
  return (
    <Wrapper
      type="button"
      background={background}
      borderRadius={borderRadius}
      width={width}
      data-loading={loading.toString()}
      data-hover={disableHover.toString()}
      disabled={disabled}
      onClick={() => {
        if (!loading && !disabled && onClick) onClick()
      }}
      {...props}
    >
      <div>{children}</div>
      {loading && <Spin spinning />}
    </Wrapper>
  )
}

export default BaseButton
